/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Action_Start_NoneInputs */

const en_us2_search_action_start_none = /** @type {(inputs: Search_Action_Start_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No workout scheduled for today`)
};

const pt_br2_search_action_start_none = /** @type {(inputs: Search_Action_Start_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sem treino marcado para hoje`)
};

const es_419_search_action_start_none = /** @type {(inputs: Search_Action_Start_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay entrenamiento programado para hoy`)
};

const pt_pt2_search_action_start_none = /** @type {(inputs: Search_Action_Start_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sem treino marcado para hoje`)
};

const fr_fr2_search_action_start_none = /** @type {(inputs: Search_Action_Start_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pas de séance prévue aujourd'hui`)
};

const de_de2_search_action_start_none = /** @type {(inputs: Search_Action_Start_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heute kein Training geplant`)
};

const it_it2_search_action_start_none = /** @type {(inputs: Search_Action_Start_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun allenamento previsto per oggi`)
};

/**
* | output |
* | --- |
* | "No workout scheduled for today" |
*
* @param {Search_Action_Start_NoneInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_action_start_none = /** @type {((inputs?: Search_Action_Start_NoneInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Action_Start_NoneInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_action_start_none(inputs)
	if (locale === "es-419") return es_419_search_action_start_none(inputs)
	if (locale === "pt-PT") return pt_pt2_search_action_start_none(inputs)
	if (locale === "fr-FR") return fr_fr2_search_action_start_none(inputs)
	if (locale === "de-DE") return de_de2_search_action_start_none(inputs)
	if (locale === "it-IT") return it_it2_search_action_start_none(inputs)
	return en_us2_search_action_start_none(inputs)
});
export { search_action_start_none as "search.action_start_none" }